import React from "react"

export const InlinedSvgs = React.memo(function InlinedSvgs(): JSX.Element {
    return (
        <div className="inlined-svgs">
            <svg
                id="inlined-svg--arrow-small"
                xmlns="http://www.w3.org/2000/svg"
                width="12.149"
                height="7.489"
                viewBox="0 0 12.149 7.489"
            >
                <path
                    d="M0,9.32,4.66,4.66,0,0"
                    transform="translate(10.735 1.414) rotate(90)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeWidth="2"
                />
            </svg>
            <svg
                id="inlined-svg--arrow-button"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
            >
                <g transform="translate(-1345.766 8.049) rotate(-45)">
                    <rect width="3" height="10" transform="translate(953 970)" fill="currentColor" />
                    <rect width="3" height="10" transform="translate(953 973) rotate(-90)" fill="currentColor" />
                </g>
            </svg>
            <svg id="inlined-svg--filter" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <rect width="40" height="40" rx="4" fill="currentColor" opacity="0" />
                <path
                    d="M370.338,870.245a7.54,7.54,0,1,1,7.54-7.54A7.508,7.508,0,0,1,370.338,870.245Zm12.877,2.991-4.079-4.081a10.623,10.623,0,0,0,2.094-6.452,10.848,10.848,0,1,0-4.441,8.8l4.081,4.081a1.621,1.621,0,0,0,2.347,0,1.621,1.621,0,0,0,0-2.347Z"
                    transform="translate(-351.72 -844.087)"
                    fill="currentColor"
                />
                <path
                    d="M779.043,458.982l-3.049,3.686v3.964a.352.352,0,0,1-.5.333l-2.023-.97a.375.375,0,0,1-.222-.332v-2.993l-3.049-3.686a.356.356,0,0,1,.277-.582h8.287a.353.353,0,0,1,.277.582Z"
                    transform="translate(-756.118 -443.4)"
                    fill="currentColor"
                />
            </svg>

            <svg
                id="inlined-svg--manage-columns"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
            >
                <g transform="translate(-11)">
                    <rect width="2" height="12" transform="translate(25 14)" fill="currentColor" />
                    <rect width="2" height="12" transform="translate(30 14)" fill="currentColor" />
                    <rect width="2" height="12" transform="translate(35 14)" fill="currentColor" />
                </g>
            </svg>

            <svg
                version="1.1"
                id="inlined-svg--ban"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="20"
                height="20"
                viewBox="0 0 120 120"
                xmlSpace="preserve"
                fill="currentColor"
            >
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M91.124,15.645c12.928,0,23.406,10.479,23.406,23.406 c0,12.927-10.479,23.406-23.406,23.406c-12.927,0-23.406-10.479-23.406-23.406C67.718,26.125,78.197,15.645,91.124,15.645 L91.124,15.645z M2.756,0h117.322c1.548,0,2.802,1.254,2.802,2.802c0,0.848-0.368,1.622-0.996,2.139l-10.667,13.556 c-1.405-1.375-2.95-2.607-4.614-3.672l6.628-9.22H9.43l37.975,46.171c0.59,0.516,0.958,1.254,0.958,2.102v49.148l21.056-9.623 V57.896c1.651,1.9,3.548,3.582,5.642,4.996v32.133c0,1.105-0.627,2.064-1.586,2.506l-26.476,12.758 c-1.327,0.773-3.023,0.332-3.798-1.033c-0.258-0.441-0.368-0.92-0.368-1.4V55.02L0.803,4.756c-1.07-1.106-1.07-2.839,0-3.945 C1.355,0.258,2.056,0,2.756,0L2.756,0z M96.93,28.282c1.328-1.349,3.489-1.355,4.825-0.013c1.335,1.342,1.341,3.524,0.013,4.872 l-5.829,5.914l5.836,5.919c1.317,1.338,1.299,3.506-0.04,4.843c-1.34,1.336-3.493,1.333-4.81-0.006l-5.797-5.878l-5.807,5.889 c-1.329,1.349-3.489,1.355-4.826,0.013c-1.335-1.342-1.341-3.523-0.013-4.872l5.83-5.913l-5.836-5.919 c-1.317-1.338-1.3-3.507,0.04-4.843c1.339-1.336,3.492-1.333,4.81,0.006l5.796,5.878L96.93,28.282L96.93,28.282z"
                    />
                </g>
            </svg>

            <svg id="inlined-svg--save" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <rect width="11" height="2" transform="translate(15 12)" fill="currentColor" />
                <path
                    d="M4.614,4.527v7.853L1.688,9.453.18,10.961l3.993,3.992L5.68,16.461l5.5-5.5L9.673,9.453,6.745,12.379V4.527Z"
                    transform="translate(14.82 12)"
                    fill="currentColor"
                />
            </svg>
            <svg
                id="inlined-svg--widget-settings"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
            >
                <rect width="40" height="40" rx="4" fill="currentColor" opacity="0" />
                <g transform="translate(-972 -135)">
                    <rect width="8" height="2" transform="translate(980 154)" fill="currentColor" />
                    <rect width="10" height="2" transform="translate(994 154)" fill="currentColor" />
                    <rect width="10" height="2" transform="translate(998 160) rotate(-90)" fill="currentColor" />
                </g>
            </svg>
            <svg
                id="inlined-svg--search"
                xmlns="http://www.w3.org/2000/svg"
                width="16.999"
                height="17"
                viewBox="0 0 16.999 17"
            >
                <path
                    d="M367.074,864.721a5.281,5.281,0,1,1,5.281-5.281A5.258,5.258,0,0,1,367.074,864.721Zm9.018,2.095-2.857-2.858a7.44,7.44,0,0,0,1.467-4.518,7.6,7.6,0,1,0-3.11,6.162l2.858,2.858a1.136,1.136,0,0,0,1.644,0,1.135,1.135,0,0,0,0-1.643Z"
                    transform="translate(-359.445 -851.812)"
                    fill="currentColor"
                />
            </svg>
            <svg
                id="inlined-svg--pencil"
                xmlns="http://www.w3.org/2000/svg"
                width="19.025"
                height="19.025"
                viewBox="0 0 19.025 19.025"
            >
                <path
                    d="M2.249,13.8,12.87,3.182l2.974,2.973L5.23,16.768l-2.98.007ZM12.87,0,0,12.921v6.1H6.105l12.92-12.87Z"
                    fill="currentColor"
                />
            </svg>

            {/* Font Awesome Free "star" icon (regular/solid), https://fontawesome.com/icons/star */}
            <svg id="inlined-svg--star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path
                    fill="currentColor"
                    d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
                />
            </svg>
            <svg id="inlined-svg--star-solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path
                    fill="currentColor"
                    d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                />
            </svg>
        </div>
    )
})

export function PDFLogoLoad({companyLogoUrl }: {companyLogoUrl: string }) {
    return ( 
        <svg xmlns="http://www.w3.org/2000/svg" display={"none"} >
            <image  xlinkHref={companyLogoUrl}/> : 
        </svg>
    )
}

export const ArrowSmallIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--arrow-small" width="12.149" height="7.489">
        <use href="#inlined-svg--arrow-small"></use>
    </svg>
)

export const ArrowIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--arrow-button" width="40" height="40">
        <use href="#inlined-svg--arrow-button"></use>
    </svg>
)

export const FilterIcon = (): JSX.Element => (
    <svg
        className="inlined-svg inlined-svg--filter"
        style={{ maxWidth: "-webkit-fill-available", maxHeight: "-webkit-fill-available" }}
    >
        <use href="#inlined-svg--filter"></use>
    </svg>
)

export const ManageColumnsIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--manage-columns" width="40" height="40">
        <use href="#inlined-svg--manage-columns"></use>
    </svg>
)

export const BanIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--ban" height="40" width="40" transform="translate(10,11)">
        <use href="#inlined-svg--ban"></use>
    </svg>
)
export const SaveIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--save" width="40" height="40">
        <use href="#inlined-svg--save"></use>
    </svg>
)

export const WidgetSettingsIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--widget-settings" width="40" height="40">
        <use href="#inlined-svg--widget-settings"></use>
    </svg>
)

export const SearchIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--search" width="17" height="17">
        <use href="#inlined-svg--search"></use>
    </svg>
)

export const PencilIcon = (): JSX.Element => (
    <svg className="inlined-svg inlined-svg--pencil" width="19" height="19">
        <use href="#inlined-svg--pencil"></use>
    </svg>
)

export const StarIcon = ({ isSet }: { isSet?: boolean }): JSX.Element => (
    <svg className="inlined-svg inlined-svg--star" width="20" height="20">
        <use href={isSet ? "#inlined-svg--star-solid" : "#inlined-svg--star"}></use>
    </svg>
)

export const CopyIcon = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-copy w-3 h-3 text-muted-foreground" aria-hidden="true">
        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
    </svg>
)